import React from "react";
// import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import "../styles/Map.css";

function MapContainer(){
  return (
    <div className="mapouter" style={{position:"relative", textAlign:"right", height: 500, width: "99.6vw"}}>
      <div className="gmap_canvas" style={{overflow:"hidden", background: "none !important", height: 500, width: "99.6vw"}}>
        <iframe title="mapsFrame" width="100%" height="500" id="gmap_canvas" src="https://maps.google.com/maps?q=+Rue+du+Musée,+38200+Vienne&t=&z=13&ie=UTF8&iwloc=&output=embed"
        // frameBorder="0" scrolling="no" marginHeight={0} marginWidth={0}
        />
      </div>
    </div>
  );
}

export default MapContainer;
